module.exports = __webpack_public_path__ + "img/puppy-footer.7ed9cad5.png";